import analytics from "web/script/analytics/analytics";
import baustein from "baustein";
import browser from "web/script/utils/browser";
import environment from "web/script/modules/environment";
import userProfiler from "web/script/modules/userprofiler";
import InstantNotification from "web/script/components/instant-notification";


export default baustein.register("instant-feedback", {
    // Message is only used to be forwarded to `InstantNotification`, we MUST use title in the
    // html for this component in order to properly initialize tippy!
    defaultOptions: {
        area: "",
        placement: "bottom",
        offset: "0, 0",
        flipBehavior: "['bottom']",
        category: "InstantFdbk",
        message: "",
    },

    init() {
        if (this.options.area === "heart") {
            this.options.category = `${this.options.category}_save`;
        } else if (this.options.area === "saved-search") {
            this.options.category = `${this.options.category}_DU`;
        }
        this.isMobile = browser.getViewport() === browser.VIEWPORTS.MOBILE;
    },

    show() {
        const isBoomInstantFeedbackOn = environment.get("boomInstantFeedback");
        if (!userProfiler.isLoggedIn() || !isBoomInstantFeedbackOn) {
            return;
        }

        if (
            (this.options.area === "heart" && userProfiler.getHeartNotificationShown()) ||
            (this.options.area === "saved-search" &&
                userProfiler.getSavedSearchtNotificationShown())
        ) {
            return;
        }

        const parrentClassName = this.el.parentElement.className;

        if (this.isMobile && parrentClassName.includes("app-header-bar")) {
            return;
        } else if (!this.isMobile && parrentClassName.includes("tabbed-bottom-navigation")) {
            return;
        }

        if (this.isMobile) {
            this.showTooltip();
        } else {
            this.showNotification();
        }
    },

    onInsert() {
        this.render();
    },

    markAsShown() {
        if (this.options.area === "heart") {
            userProfiler.setHeartNotificationShown();
        } else if (this.options.area === "saved-search") {
            userProfiler.setSavedSearchtNotificationShown();
        } else {
            throw Error(
                "Did not receive correct 'area' set when initializing instant-feedback component"
            );
        }
    },

    showNotification() {
        // analytics event is triggered withing the InstantNotification component
        const instantNotification = new InstantNotification({
            icon: this.options.area,
            message: this.options.message,
            category: this.options.category,
        });
        instantNotification.appendTo(document.body);
        this.markAsShown();
    },

    showTooltip() {
        this.el._tippy.show();
        this.markAsShown();
    },

    dismiss() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        analytics.event(this.options.category, "Clicked", "Close").then(() => {
            this.el._tippy.hide();
        });
    },

    render() {
        const options = {
            ...this.options,
            onShow: () => {
                analytics.event(this.options.category, "shown", null, true);
                // tooltip's close btn is available after `instant-feedback`` component is
                // initialized, meaning we can't use setupEvent()
                const closeIcon = this.el._tippy.popper.querySelector(".instant-feedback__close");
                closeIcon.addEventListener("click", this.dismiss.bind(this));
                this.timeout = setTimeout(() => {
                    analytics.event(this.options.category, "AutoHide", null, true).then(() => {
                        this.el._tippy.hide();
                    });
                }, 5000);
            },
            theme: "light",
            zIndex: 999,
            trigger: "manual",
            interactive: true,
            interactiveBorder: 20,
            arrow: true,
            hideOnClick: false,
        };

        import( /* webpackChunkName: "tippy" */ "tippy.js").then(({
            default: tippy,
        }) => {
            tippy(this.el, options);
        });
    },
});
